<template>
  <div>
    <span class="hidden" id="imageShow" @click="showImage"></span>

    <vue-easy-lightbox
        moveDisabled
        :visible="visible"
        :imgs="imgs"
        :index="index"
        @hide="visible = false"
    ></vue-easy-lightbox>
  </div>
</template>
<script>

export default {
    props: ['paramImages'],
    components: {
    },
    data() {
      return {
        imgs: [],
        visible: false,
        index: 0
      }
    },
    mounted() {
      this.imgs = JSON.parse(this.paramImages)
    },
    beforeDestroy() {
    },
    methods: {
      showImage() {
        this.index = parseInt($('#imageShow').data('index'));
        this.visible = true
      }
    },
    computed: {
    }
}
</script>
<style scoped lang="scss">
  .comment-image {
    margin-bottom: 1rem;

    img {
        width: 100%;
        max-height: 300px;
        object-fit: contain;
    }
  }
</style>